import { render, staticRenderFns } from "./agent-profile.vue?vue&type=template&id=fa5b22ce"
import script from "./agent-profile.vue?vue&type=script&lang=js"
export * from "./agent-profile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports